// src/plugins/mention-no-space.plugin.js
import Plugin from '@ckeditor/ckeditor5-core/src/plugin';

export default class MentionNoSpacePlugin extends Plugin {
	static get pluginName() {
		return 'MentionNoSpacePlugin';
	}

	init() {
		const editor = this.editor;

		editor.editing.view.document.on(
			'keydown',
			( evt, data ) => {
				if ( data.keyCode !== 8 && data.keyCode !== 46 ) {
					return;
				}

				const model = editor.model;
				const selection = model.document.selection;
				const position = selection.getFirstPosition();

				if ( !position ) {
					return;
				}

				const nodeBefore = position.nodeBefore;
				const nodeAfter = position.nodeAfter;

				let mentionNode = null;

				if (
					nodeBefore &&
					nodeBefore.is &&
					nodeBefore.is( '$text' ) &&
					nodeBefore.hasAttribute &&
					nodeBefore.hasAttribute( 'mention' )
				) {
					mentionNode = nodeBefore;
				} else if (
					nodeAfter &&
					nodeAfter.is &&
					nodeAfter.is( '$text' ) &&
					nodeAfter.hasAttribute &&
					nodeAfter.hasAttribute( 'mention' )
				) {
					mentionNode = nodeAfter;
				}

				if ( !mentionNode ) {
					return;
				}

				evt.stop();
				data.preventDefault();

				model.change( writer => {
					writer.remove( writer.createRangeOn( mentionNode ) );
				} );
			},
			{ priority: 'high' }
		);
	}
}
